export const mcn = (...args: Array<string | undefined | false>) => {
  return args.filter(Boolean).join(" ");
};
